import React from "react";
// TEMPORARILY DISABLED: import useIframeAuth from "../hooks/useIframeAuth";

const NoPage = () => {
    // TEMPORARILY DISABLED: const { isAuthorized, isChecking } = useIframeAuth();

    /* TEMPORARILY DISABLED: iframe auth check
    // Show loader while checking iframe auth
    if (isChecking) {
      return (
        <div className="app-container">
          <div id="loader" className="loader"></div>
        </div>
      );
    }

    // If not authorized, component will redirect (handled by hook)
    if (!isAuthorized) {
      return null;
    }
    */

    return (
        <div className="app-container">
            <h1>404</h1>
        </div>
    )
  };
  
  export default NoPage;